// Session token storage for the web port of the warehouse app.
//
// The React Native web build stores the session in document.cookie, but
// this app renders inside the BigCommerce iframe where cross-site cookie
// writes are unreliable (Safari ITP blocks them entirely), so this port
// uses localStorage with the same keys instead. The functions stay async
// so the ported store code keeps its original shape.
const SESSION_TOKEN_KEY = 'session_token';
const SESSION_EMAIL_KEY = 'session_email';
const SESSION_PROFILE_KEY = 'session_profile';

export async function getSessionToken() {
  return localStorage.getItem(SESSION_TOKEN_KEY);
}

export async function setSessionToken(token) {
  localStorage.setItem(SESSION_TOKEN_KEY, token);
}

export async function clearSessionToken() {
  localStorage.removeItem(SESSION_TOKEN_KEY);
  localStorage.removeItem(SESSION_EMAIL_KEY);
  localStorage.removeItem(SESSION_PROFILE_KEY);
}

// The logged-in user's email - used to tell which in-progress batches
// belong to this session so they can be re-entered
export async function getSessionEmail() {
  return localStorage.getItem(SESSION_EMAIL_KEY);
}

export async function setSessionEmail(email) {
  localStorage.setItem(SESSION_EMAIL_KEY, email);
}

// Location + permissions returned at login - drives the profile screen
// and which workflows the navigation offers
export async function getSessionProfile() {
  const raw = localStorage.getItem(SESSION_PROFILE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export async function setSessionProfile(profile) {
  localStorage.setItem(SESSION_PROFILE_KEY, JSON.stringify(profile));
}
